import classNames from '@utils/ClassNames';
import { DisclosureElement } from './DisclosureWithLinksElement';

export interface DisclosureWrapperArgs {
  content: Array<{
    headline: string;
    sublines: Array<{
      title: string;
      href: string;
    }>;
  }>;
  headline: string;
  className?: string;
}

export const DisclosureWrapper = ({ content, className, headline }: DisclosureWrapperArgs) => (
  <div
    className={classNames(
      'flex flex-col px-6 py-9 bg-accent-primary_005 rounded-lg space-y-8',
      className,
    )}
  >
    <p className="uppercase text-h-20">{headline}</p>
    {content.map((element, index) => (
      <DisclosureElement
        key={index + element.headline}
        headline={element.headline}
        sublines={element.sublines}
      />
    ))}
  </div>
);
